export const RATING_LABELS = ["Unsatisfactory", "Needs improvement", "Fully successful", "Exceeds", "Outstanding"];

export function scoreAnswers(template, answers) {
  if (!template?.bands) return null;
  let earned = 0, possible = 0;
  template.sections.forEach((s) => s.fields.forEach((f) => {
    if (f.type !== "rating") return;
    const v = Number(answers[f.id]);
    if (!v) return;
    const w = f.weight || 1;
    earned += v * w;
    possible += 5 * w;
  }));
  if (!possible) return null;
  const percent = Math.round((earned / possible) * 1000) / 10;
  const band = template.bands.find(([cutoff]) => percent >= cutoff)?.[1];
  return { earned, possible, percent, band };
}

export function bandColor(percent) {
  if (percent == null) return "bg-slate-100 text-slate-700";
  if (percent >= 85) return "bg-emerald-100 text-emerald-800";
  if (percent >= 70) return "bg-[#DBEAFE] text-[#0A2A5E]";
  if (percent >= 55) return "bg-[#FDECD0] text-[#7C3F00]";
  return "bg-rose-100 text-rose-800";
}

export function allFields(template) {
  return template.sections.flatMap((s) => s.fields);
}
